import React from "react";
import Helmet from "react-helmet";
import { graphql, StaticQuery } from "gatsby";
import { ISeoMetatags } from "~src/interfaces/plugins";

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
        siteUrl
      }
    }
  }
`;

interface ISEOProps {
  lang?: string;
  keywords?: string[]; // TODO:
  image?: string;
  centralSeoData: ISeoMetatags;
  googleSiteVerification: string;
  noindex: boolean;
}

function SEO(props: ISEOProps) {
  const {
    image,
    centralSeoData,
    keywords,
    lang = "en",
    googleSiteVerification,
    noindex = false,
  } = props;

  return (
    <StaticQuery
      query={detailsQuery}
      render={(data: any): any => {
        const { siteMetadata: gatsbyConfigMetadata }: any = data.site;
        const metaTags: any = [
          {
            content: gatsbyConfigMetadata?.author || "",
            name: "author",
          },
          {
            content: centralSeoData?.title || gatsbyConfigMetadata.title, // Replace centralSeoData.og_title with the actual OG title value
            property: "title",
          },
          {
            content: centralSeoData?.og_title || gatsbyConfigMetadata.title, // Replace centralSeoData.og_title with the actual OG title value
            property: "og:title",
          },
          // Meta Description - Search Engines
          {
            content: centralSeoData?.description || gatsbyConfigMetadata.description, // Replace "blabla" with the actual meta description value
            name: "description",
          },
          // OG Description - Social Platforms
          {
            content: centralSeoData?.og_description || gatsbyConfigMetadata.description, // Replace "ogdescription LONG" with the actual OG description value
            property: "og:description",
          },
          {
            content: centralSeoData?.og_image || image, // Replace centralSeoData.og_image or image with the actual OG image URL
            property: "og:image",
          },
          {
            content: "website",
            property: "og:type",
          },
          {
            content: centralSeoData?.twitter_title || gatsbyConfigMetadata.title, // Replace centralSeoData.twitter_title with the actual Twitter title value
            name: "twitter:title",
          },
          {
            content: centralSeoData?.twitter_description || gatsbyConfigMetadata.description, // Replace centralSeoData.twitter_description with the actual Twitter description value
            name: "twitter:description",
          },
          {
            content: googleSiteVerification, // Replace googleSiteVerification with the actual Google Site Verification value
            name: "google-site-verification",
          },
          {
            content: noindex ? "noindex" : null,
            name: "robots",
          },
          {
            name: "referrer",
            content: "no-referrer",
          },
          {
            name: "Referrer-Policy",
            content: "same-origin",
          },
          {
            name: "X-Frame-Options",
            content: "SAMEORIGIN",
          },
        ]
          .filter((e) => e.content)
          .concat(
            keywords && keywords.length > 0
              ? {
                content: keywords.join(", "),
                name: "keywords",
              }
              : []
          );

        return (
          <Helmet
            htmlAttributes={{
              lang,
            }}
            title={centralSeoData?.title || gatsbyConfigMetadata.title}
          >
            {metaTags.map((tag: any, index: any): JSX.Element => (
              <meta key={index as number} {...tag as any} />
            ))}
            <script
              type="text/javascript"
              src="https://ef.com/scripts/analytics/efanalyticstk.min.js"
              async
            />
          </Helmet>
        );
      }}
    />
  );
}

export default SEO;
